jQuery(function($)
{
    var cartApi = orion.api.cart;
    var shoppingListApi = orion.api.shoppinglist;
    var orderListApi = orion.api.orderlist;
    var $body = $('body');
    var take = 100;
    var $progressBar = $('#cart-to-csv-progress, #shoppinglist-to-csv-progress, #orderlist-to-csv-progress');
    var indexArray = [
        'productBarcode', 'productBarcodeType', 'productNumber', 'productName', 'productVariation', 'packagingSize',
        'undiscountedPrice', 'discountedPrice', 'subtotalPrice', 'taxInPercent', 'quantity', 'weight'
    ];

    function downloadCartAsCsv(event)
    {
        event.preventDefault();

        var cartProductItemCount = 0;

        cartApi.read().done(function(data)
        {
            cartProductItemCount = data.response.cart.productItemCount;

            if (cartProductItemCount >= 1)
            {
                updateProgressBar('0');
                startCsvConversionForCart(cartProductItemCount);
            }
            else
            {
                console.warn('Empty cart');
            }
        });
    }

    function downloadOrderlistAsCsv(event)
    {
        event.preventDefault();

        var orderlistProductItemCount = 0;
        var orderlistId = $(this).data('orderid');

        orderListApi.read().done(function(data)
        {
            var orderlist = null;
            for (const orderlistKey in data.orderLists)
            {
                if (data.orderLists[orderlistKey].orderId === orderlistId)
                {
                    orderlist = data.orderLists[orderlistKey];
                    break;
                }
            }

            if ( orderlist == null )
            {
                console.warn('Orderlist not found!');
                return;
            }

            orderlistProductItemCount = orderlist.productItemCount;

            if (orderlistProductItemCount >= 1)
            {
                updateProgressBar('0');
                startCsvConversionForOrderlist(orderlistId, orderlistProductItemCount);
            }
            else
            {
                console.warn('Empty orderlist');
            }
        });
    }


    function initEvents()
    {
        $body.off('click', '.js-download-cart-as-csv');
        $body.on('click', '.js-download-cart-as-csv', downloadCartAsCsv);

        $body.off('click', '.js-download-shoppinglist-as-csv');
        $body.on('click', '.js-download-shoppinglist-as-csv', downloadShoppingListAsCsv);

        $body.off('click', '.js-download-orderlist-as-csv');
        $body.on('click', '.js-download-orderlist-as-csv', downloadOrderlistAsCsv);

        $body.on(orion.constants.EventOrderlistItemLoaded, initOrderListAsCsvEvents);
    }

    function initOrderListAsCsvEvents()
    {
        $body.off('click', '.js-download-orderlist-as-csv');
        $body.on('click', '.js-download-orderlist-as-csv', downloadOrderlistAsCsv);
    }

    function startCsvConversionForCart(cartProductItemCount)
    {
        var csv = '';

        cartApi.readItems(0, 1).done(function(data)
        {
            var itemArray = data.response.productItems;
            var line = '';

            for (var index in itemArray[0])
            {
                if (!Object.prototype.hasOwnProperty.call(itemArray[0], index))
                {
                    continue;
                }
                if (jQuery.inArray(index, indexArray) !== -1)
                {
                    if (line !== '')
                    {
                        line += ',';
                    }
                    if (index === 'productBarcode')
                    {
                        index = 'barcode';
                    }
                    else if (index === 'productBarcodeType')
                    {
                        index = 'barcodeType';
                    }
                    line += '"' + index + '"';
                }
            }
            csv += line + '\r\n';
            csv = $('<div/>').html(csv)
                .text();
            readCartItemsAndConvertToCsv(cartProductItemCount, csv, 0, take);
        });
    }

    function readCartItemsAndConvertToCsv(cartProductItemCount, csv, skip, take)
    {
        cartApi.readItems(skip, take).done(function(data)
        {
            var progress = ( skip / cartProductItemCount ) * 100;

            updateProgressBar(progress);
            csv += convertToCsv(data.response.productItems);
            skip += take;
            if (skip < cartProductItemCount)
            {
                readCartItemsAndConvertToCsv(cartProductItemCount, csv, skip, take);
            }
            else
            {
                progress = ( skip / cartProductItemCount ) * 100;
                updateProgressBar(progress);
                triggerCsvDownload(csv, 'cart.csv');
            }
        });
    }

    function downloadShoppingListAsCsv(event)
    {
        event.preventDefault();

        var shoppingListId = $(this).closest('.csv-cell')
            .data('uid');
        var shoppingListName = $(this).closest('.csv-cell')
            .data('list-name');

        console.log(shoppingListName);

        shoppingListApi.readHeaderData(shoppingListId).done(function(data)
        {
            console.log('done');
            var shoppingListProductItemCount = data.productItemCount;

            if (shoppingListProductItemCount >= 1)
            {
                updateProgressBar('0');
                startCsvConversionForShoppingList(shoppingListId, shoppingListProductItemCount, shoppingListName);
            }
            else
            {
                console.warn('Empty shoppinglist');
            }
            console.log(shoppingListName);
        });
    }

    function startCsvConversionForShoppingList(shoppingListId, shoppingListProductItemCount, shoppingListName)
    {
        console.log('startCsvConversionForShoppingList');
        var csv = '';

        shoppingListApi.readItems(shoppingListId, 0, 1).done(function(data)
        {
            var itemArray = data.response.productItems;
            var line = '';

            for (var index in itemArray[0])
            {
                if (!Object.prototype.hasOwnProperty.call(itemArray[0], index))
                {
                    continue;
                }
                if (jQuery.inArray(index, indexArray) !== -1)
                {
                    if (line !== '')
                    {
                        line += ',';
                    }
                    if (index === 'productBarcode')
                    {
                        index = 'barcode';
                    }
                    else if (index === 'productBarcodeType')
                    {
                        index = 'barcodeType';
                    }
                    line += '"' + index + '"';
                }
            }
            csv += line + '\r\n';
            csv = $('<div/>').html(csv)
                .text();
            readShoppingListItemsAndConvertToCsv(shoppingListId, shoppingListProductItemCount,
                csv, 0, take, shoppingListName);
        });
    }

    function readShoppingListItemsAndConvertToCsv(
        shoppingListId,
        shoppingListProductItemCount,
        csv,
        skip,
        take,
        shoppingListName
    )
    {
        shoppingListApi.readItems(shoppingListId, skip, take).done(function(data)
        {
            var progress = ( skip / shoppingListProductItemCount ) * 100;

            updateProgressBar(progress);
            csv += convertToCsv(data.response.productItems);
            skip += take;
            if (skip < shoppingListProductItemCount)
            {
                readShoppingListItemsAndConvertToCsv(shoppingListId, shoppingListProductItemCount,
                    csv, skip, take, shoppingListName);
            }
            else
            {
                progress = ( skip / shoppingListProductItemCount ) * 100;
                updateProgressBar(progress);
                triggerCsvDownload(csv, shoppingListName + '.csv');
            }
        });
    }

    function startCsvConversionForOrderlist(orderlistId, orderlistProductItemCount)
    {
        var csv = '';

        orderListApi.readItems(orderlistId, 0, 1).done(function(data)
        {
            var itemArray = data.orderListItems;
            var line = '';

            for (var index in itemArray[0])
            {
                if (!Object.prototype.hasOwnProperty.call(itemArray[0], index))
                {
                    continue;
                }
                if (jQuery.inArray(index, indexArray) !== -1)
                {
                    if (line !== '')
                    {
                        line += ',';
                    }
                    if (index === 'productBarcode')
                    {
                        index = 'barcode';
                    }
                    else if (index === 'productBarcodeType')
                    {
                        index = 'barcodeType';
                    }
                    line += '"' + index + '"';
                }
            }
            csv += line + '\r\n';
            csv = $('<div/>').html(csv)
                .text();
            readOrderlistItemsAndConvertToCsv(orderlistId, orderlistProductItemCount, csv, 0, take);
        });
    }

    function readOrderlistItemsAndConvertToCsv(orderlistId, orderlistProductItemCount, csv, skip, take)
    {
        orderListApi.readItems(orderlistId, skip, take).done(function(data)
        {
            var progress = ( skip / orderlistProductItemCount ) * 100;

            updateProgressBar(progress);
            csv += convertToCsv(data.orderListItems);
            skip += take;
            if (skip < orderlistProductItemCount)
            {
                readOrderlistItemsAndConvertToCsv(orderlistId, orderlistProductItemCount, csv, skip, take);
            }
            else
            {
                progress = ( skip / orderlistProductItemCount ) * 100;
                updateProgressBar(progress);
                triggerCsvDownload(csv, 'orderlist.csv');
            }
        });
    }

    function triggerCsvDownload(csv, name)
    {
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

        if (navigator.msSaveBlob)
        {
            navigator.msSaveBlob(blob, name); // IE handling
        }
        else
        {
            var element = document.createElement('a');
            var url = URL.createObjectURL(blob);

            element.setAttribute('href', url);
            element.setAttribute('download', name);
            element.style.display = 'none';

            $body.append(element);
            element.click();
            $body.remove(element);
        }
    }

    function convertToCsv(itemArray)
    {
        var csv = '';

        for (var i = 0; i < itemArray.length; i++)
        {
            var line = '';

            for (var index in itemArray[i])
            {
                if (!Object.prototype.hasOwnProperty.call(itemArray[i], index))
                {
                    continue;
                }
                if (jQuery.inArray(index, indexArray) !== -1)
                {
                    if (line !== '')
                    {
                        line += ',';
                    }
                    line += '"' + itemArray[i][index] + '"';
                }
            }
            csv += line + '\r\n';
        }
        return $('<div/>').html(csv)
            .text();
    }

    // see csvOrder.js
    function updateProgressBar(value)
    {
        var progressValueRounded = Math.ceil(value);

        if (progressValueRounded > 100)
        {
            progressValueRounded = 100;
        }
        var progressValuePercentage = progressValueRounded + '%';

        console.log('progress: ' + progressValuePercentage);

        $progressBar.removeClass('hidden');
        $body.addClass('focus-active');
        $('.progress-meter', $progressBar).css('width', progressValuePercentage);
        $('.progress-meter-text', $progressBar).text(progressValuePercentage);

        if (progressValueRounded >= 100)
        {
            setTimeout(function()
            {
                $progressBar.addClass('hidden');
                $body.removeClass('focus-active');
            }, 1000);
        }
    }

    initEvents();

    $body.on(orion.constants.EventCsvDownloadButtonAppended, initEvents);
});
